/**
 * User-initiated return to the installed MovieMe iOS app after browser auth.
 * Custom scheme only — never attach tokens, email, or passwords.
 */
export const MOVIEME_APP_HOME_URL = 'movieme://home';

/** Open the installed MovieMe app at home. No-op if the scheme is unsupported. */
export function openMovieMeApp(): void {
  if (typeof window === 'undefined') return;
  window.location.assign(MOVIEME_APP_HOME_URL);
}
